import React, { useEffect, useState, useCallback } from 'react';
import AntToolbar from './AntToolbar';
import AntLocalization from '../utils/AntLocalization';
import AntWidgetSkeleton from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

var getGaugeColor = (pct) => {
    if (pct >= 80) return '#3d7a6a';
    if (pct >= 50) return 'var(--AnteBaseColor1)';
    if (pct >= 30) return '#b8860b';
    return '#b34040';
};

function GaugeRing(ringProps) {
    var size = ringProps.size || 100;
    var strokeWidth = ringProps.strokeWidth || 6;
    var pct = Math.min(Math.max(ringProps.percent || 0, 0), 100);
    var radius = (size - strokeWidth) / 2;
    var circumference = 2 * Math.PI * radius;
    var offset = circumference - (pct / 100) * circumference;
    var color = ringProps.color || getGaugeColor(pct);
    var center = size / 2;

    return (
        <div className="ant-widget-gauge__ring">
            <svg width={size} height={size} viewBox={'0 0 ' + size + ' ' + size}>
                <circle
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    stroke="#627aaf18"
                    strokeWidth={strokeWidth}
                />
                <circle
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    transform={'rotate(-90 ' + center + ' ' + center + ')'}
                    style={{ transition: 'stroke-dashoffset 0.6s ease' }}
                />
            </svg>
            <div className="ant-widget-gauge__center">
                <span className="ant-widget-gauge__pct">{pct.toFixed(0)}%</span>
            </div>
            {ringProps.label && (
                <div className="ant-widget-gauge__label">{typeof ringProps.label === 'object' ? AntLocalization.translateText(ringProps.label) : ringProps.label}</div>
            )}
        </div>
    );
}

export default function (props) {
    var [data, setData] = useState({});
    var [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url));

    var load = useCallback(async () => {
        if (props.url) {
            props.API.post(props.url, { ...props.searchConditions }, (resp) => {
                if (resp && !resp.error && resp.data) setData(resp.data);
                else setData({});
                markLoaded();
            });
        }
    }, [props.API, props.url, props.searchConditions, markLoaded]);

    useEffect(() => {
        load();
        var interval = setInterval(load, 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        load();
    }, [props.searchConditions, props.url]);

    useEffect(() => {
        if (props.dataSource && !props.url) setData(props.dataSource);
    }, [props.dataSource]);

    var gaugeItems = props.items || [];
    var gaugeSize = props.gaugeSize || 100;
    var strokeWidth = props.strokeWidth || 6;

    if (gaugeItems.length === 0 && props.valueField) {
        gaugeItems = [{ valueField: props.valueField, targetField: props.targetField, label: props.gaugeLabel, color: props.gaugeColor }];
    }

    if (!loaded) {
        return (
            <React.Fragment>
                {props.title && <AntToolbar title={props.title} isH6={true} upperCase={true} />}
                <AntWidgetSkeleton variant="gauge" count={gaugeItems.length || 1} gaugeSize={gaugeSize} />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            {props.title && <AntToolbar title={props.title} isH6={true} upperCase={true} />}
            <div className="ant-widget-gauge">
                <div className="ant-widget-gauge__row">
                    {gaugeItems.map((item, idx) => {
                        var value = parseFloat(data[item.valueField]) || 0;
                        var target = parseFloat(data[item.targetField]) || 100;
                        var pct = target > 0 ? (value / target) * 100 : 0;
                        return <GaugeRing key={idx} percent={pct} label={item.label} color={item.color} size={gaugeSize} strokeWidth={strokeWidth} />;
                    })}
                </div>
            </div>
        </React.Fragment>
    );
}
